import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { RootStore } from '../../../../redux/store'
import { featureToggleKeys } from '../../../../types/feature-toggles'
import { SettingsResponse } from '../../../../types/settings-response'

interface UseManualAuthorizationResult {
  isManAuthOn: boolean
  isManAuthAllowed: boolean
}

const featureToggleKeyMap: Record<string, keyof RootStore['featureToggles']> = {
  [featureToggleKeys.ManAuthUK]: 'manAuthUK',
}

export const useManAuth = (featureToggleName: string, departmentSettings: SettingsResponse | null): UseManualAuthorizationResult => {
  const statePropertyName = featureToggleKeyMap[featureToggleName]

  const featureToggle = useSelector((state: RootStore) => state.featureToggles[statePropertyName])

  const isManAuthAllowed = useMemo(() => Boolean(departmentSettings?.isManAuthAllowed), [departmentSettings])
  const isManAuthOn = useMemo(
    () => Boolean(featureToggle && isManAuthAllowed),
    [featureToggle, isManAuthAllowed]
  )

  return {
    isManAuthOn,
    isManAuthAllowed,
  }
}
